import * as Storage from "aws-amplify/storage";
import {
  Field,
  FieldProps
} from "formik";
import React, {
  DetailedHTMLProps,
  InputHTMLAttributes,
  SelectHTMLAttributes,
  TextareaHTMLAttributes
} from "react";
import styled, { css } from "styled-components";

type InputProps = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;
type InputTextAreaProps = DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>;
type InputSelectProps = DetailedHTMLProps<SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement>;

export const StyledInput = styled.input`
  outline: none;
  border: none;
  height: 40px;
  width: 100%;
  font-size: ${({ theme }) => theme.fonts.sizes.h2};
  line-height: 35px;
  margin: 10px 0;
  padding-left: 10px;

  ${({ theme }) => css`
    background: ${theme.colors.white};
    border-bottom: 1px solid ${theme.colors.lightGrey};
    color: ${theme.fonts.colors.primary};

    &:-webkit-autofill {
      background: ${theme.colors.white};
      -webkit-text-fill-color: ${theme.fonts.colors.primary};
      -webkit-transition-delay: 99999s;
    }
  `};

  box-sizing: border-box;
  max-width: 400px;
`;

export const InputField = ({ field, ...props }: FieldProps & InputProps & { ref: any }) => {
  return (
    <StyledInput
      {...field}
      {...props}
    />
  );
};

const StyledTextArea = styled.textarea`
  width: 100%;
  padding: 10px;

  ${({ theme }) => `
  font-size: ${theme.fonts.sizes.p};

  :disabled {
    background: ${theme.colors.lightGrey};
  }
  `}
`;

export const InputTextArea = ({ field, ...props }: FieldProps & InputTextAreaProps & { ref: any }) => {
  return (
    <StyledTextArea
      {...field}
      {...props}
      disabled={props.disabled}
    />
  );
};

const StyledSelect = styled.select`
  ${({ theme }) => `
    font-size: ${theme.fonts.sizes.p};
  `}

  outline: none;
  border: none;
  height: 40px;
  width: 100%;
  min-width: 100px;

  line-height: 35px;
  box-sizing: border-box;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  margin: 10px 0;
`;

export const InputSelect = ({ field, ...props }: FieldProps & InputSelectProps & { ref: any }) => {
  return (
    <StyledSelect
      {...field}
      {...props}
    />
  );
};

const FileUploadButton = styled.div`
  position: relative;
  display: inline-block;

  ${({ theme }) => `
  .btn {
    border: 1px solid ${theme.colors.primaryLight};
    color: white;
    background-color: ${theme.colors.primaryLight};
    padding: 8px 20px;
    font-size: ${theme.fonts.sizes.h2};
    width: 300px;
    height: 200px;
    margin: 5px;
    margin-left: 0;
  }
  `}

  input[type="file"] {
    width: 300px;
    height: 200px;
    font-size: 100px;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
  }
`;

const uploadToS3 = (evt: any, form: any) => {
  const file = evt.target.files[ 0 ];

  Storage.uploadData({
    path: file.name,
    data: file,
    options: { contentType: file.type }
  }).result.then(result => {
    form.setFieldValue("productImage", `${process.env.REACT_APP_S3_BUCKET}${result.path}`);
  })
    .catch(err => console.error(err));
};

export const InputImage = ({
  field, form, ...props
}: FieldProps & InputProps) => {
  return (
    <FileUploadButton>
      <button
        className="btn"
        type="button"
      >
        +
      </button>

      <input
        accept="image/png, image/jpeg"
        type="file"
        {...field}
        {...props}
        onChange={evt => uploadToS3(evt, form)}
      />
    </FileUploadButton>
  );
};

export const CheckboxStyled = styled.input.attrs({ type: "checkbox" })`
  width: 20px;
  height: 20px;
  :before {
    /* content: ""; */
    background: #fff;
    display: block;
    width: 20px;
    height: 20px;
    border-radius: 5px;
  }
`;

export const InputCheckbox = (props: any) => {
  return (
    <Field name={props.name}>
      {({ field, form }: { field: any; form: any }) => (
        <label>
          <CheckboxStyled
            {...props}
            checked={field.value.includes(props.value)}
            onChange={() => {
              if (field.value.includes(props.value)) {
                const nextValue = field.value.filter((value: any) => value !== props.value);

                form.setFieldValue(props.name, nextValue);
              } else {
                const nextValue = field.value.concat(props.value);

                form.setFieldValue(props.name, nextValue);
              }
            }}
          />

          {props.label}
        </label>
      )}
    </Field>
  );
};
